import { Controller } from "@hotwired/stimulus"
import { createLogger, nodeToString } from "@/javascript/utils/logging"

// Connects to data-controller="turbo-list-signaling"
export default class extends Controller {
  static targets = [ "signal" ]
  static values = { suppressForId: String }

  start = Date.now();

  connect() {
    this.logger = createLogger('TurboListSignalingController')
    this.logger.debug('TurboListSignalingController connected')
  }

  debounce = (callback, wait, timerId) => {
    return (...args) => {
      window.clearTimeout(timerId);
      const promiseForFunc = new Promise((resolve) => {
        timerId = window.setTimeout(resolve, wait);
      });

      return promiseForFunc.then(() => callback(...args));
    };
  }

  signalTargetConnected(element){
    this.logger.debug(`signalTargetConnected - ${nodeToString(element)}`)

    element.dataset.signalRecieved = Date.now()
    this.timerId = element.dataset.modelId
    this.sumbitRefreshRequest(element)
  }

  sumbitRefreshRequest = this.debounce((element) => {
    if(this.suppressForIdValue == element.dataset.modelId){
      this.logger.info('sumbitRefreshRequest - sumbitRefreshRequest suppressed')

      this.suppressForIdValue = null
      return
    }
    const form = this.element;
    const url = new URL(form.action);
    url.searchParams.set('turbo_list_upserted_model_id', element.dataset.modelId);
    form.action = url.toString();
    
    form.requestSubmit();
    element.dataset.signalSent = Date.now();

    this.logger.debug('sumbitRefreshRequest - Sent refresh request to', form.action)
  }, 250, this.timerId)
}
